import {
  createRouter,
  createWebHistory,
  NavigationGuardNext,
  RouteLocationNormalized,
  RouteRecordRaw,
} from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import { permissions } from "@/core/helpers/permission";
import { reactive, watchEffect } from "vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/admin",
    redirect: "/admin/thong-bao-noi-bo",
  },
  {
    path: "/admin/trang-chu",
    redirect: "/admin/thong-bao-noi-bo",
  },
  {
    path: "/",
    redirect: "/admin/thong-bao-noi-bo",
    component: () => import("@/layouts/main-layout/MainLayout.vue"),
    meta: {
      pageTitle: "Thông báo nội bộ",
      middleware: "auth",
      permission: " ",
    },
    children: [
      // {
      //   path: "/admin/trang-chu",
      //   name: "manager.dashboard",
      //   component: () => import("@/views/manager/pages/dashboard/index.vue"),
      //   meta: {
      //     breadcrumbs: [],
      //   },
      //   children: [
      //     {
      //       path: "tin-tuc-noi-bo",
      //       name: "manager.dashboard.internal-news",
      //       component: () =>
      //         import(
      //           "@/views/manager/pages/dashboard/internal-news/list/index.vue"
      //         ),
      //       meta: {
      //         breadcrumbs: [],
      //       },
      //     },
      //   ],
      // },
      {
        path: "/admin/nguoi-dung",
        name: "manager.user",
        component: () => import("@/views/manager/pages/user/list/index.vue"),
        meta: {
          pageTitle: "Danh sách người dùng",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.user.add",
            permission: permissions.MANAGER_AND_ROLE_ADD,
          },
          breadcrumbs: [],
          permission: permissions.MANAGER_AND_ROLE_ACCESS,
        },
      },
      {
        path: "/admin/nguoi-dung/add",
        name: "manager.user.add",
        component: () =>
          import("@/views/manager/pages/user/add_edit/index.vue"),
        meta: {
          pageTitle: "Tạo người dùng",
          breadcrumbs: [
            {
              title: "Danh sách người dùng",
              routeName: "manager.user",
            },
            {
              title: "Tạo người dùng",
              routeName: "manager.user.add",
            },
          ],
          permission: permissions.MANAGER_AND_ROLE_ADD,
        },
      },
      {
        path: "/admin/nguoi-dung/edit/:id",
        name: "manager.user.edit",
        component: () =>
          import("@/views/manager/pages/user/add_edit/index.vue"),
        meta: {
          pageTitle: "Cập nhật người dùng",
          breadcrumbs: [
            {
              title: "Danh sách người dùng",
              routeName: "manager.user",
            },
            {
              title: "Cập nhật người dùng",
              routeName: "manager.user.edit",
            },
          ],
          permission: permissions.MANAGER_AND_ROLE_EDIT,
        },
      },
      {
        path: "/admin/nguoi-dung/detail/:id",
        name: "manager.user.detail",
        component: () => import("@/views/manager/pages/user/detail/index.vue"),
        meta: {
          pageTitle: "Chi tiết người dùng",
          breadcrumbs: [
            {
              title: "Danh sách người dùng",
              routeName: "manager.user",
            },
            {
              title: "Chi tiết người dùng",
              routeName: "manager.user.detail",
            },
          ],
          permission: permissions.MANAGER_AND_ROLE_ACCESS,
        },
      },
      {
        path: "/admin/thong-bao-noi-bo",
        name: "manager.thongBaoNoiBo",
        component: () =>
          import("@/views/manager/pages/thong-bao-noi-bo/list/index.vue"),
        meta: {
          pageTitle: "Thông báo nội bộ",
          breadcrumbs: [],
          permission: permissions.INTERNAL_INFORMATION,
        },
      },
      {
        path: "/admin/thong-bao-noi-bo/chi-tiet/:id",
        name: "manager.thongBaoNoiBo.detail",
        component: () =>
          import("@/views/manager/pages/thong-bao-noi-bo/detail/index.vue"),
        meta: {
          pageTitle: "Chi tiết thông báo nội bộ",
          breadcrumbs: [
            {
              title: "Danh sách thông báo nội bộ",
              routeName: "manager.thongBaoNoiBo",
            },
            {
              title: "Chi tiết thông báo nội bộ",
              routeName: "manager.thongBaoNoiBo.detail",
            },
          ],
          permission: permissions.INTERNAL_INFORMATION,
        },
      },
      {
        path: "/admin/van-ban-noi-bo",
        name: "manager.internalDocument",
        component: () =>
          import("@/views/manager/pages/internal-documents/list/index.vue"),
        meta: {
          pageTitle: "Văn bản nội bộ",
          permission: permissions.INTERNAL_INFORMATION,
        },
      },
      {
        path: "/admin/van-ban-noi-bo/chi-tiet/:id",
        name: "manager.internalDocument.detail",
        component: () =>
          import("@/views/manager/pages/internal-documents/detail/index.vue"),
        meta: {
          pageTitle: "Chi tiết văn bản nội bộ",
          breadcrumbs: [
            {
              title: "Danh sách văn bản nội bộ",
              routeName: "manager.internalDocument",
            },
            {
              title: "Chi tiết văn bản nội bộ",
              routeName: "manager.internalDocument.detail",
            },
          ],
          permission: permissions.INTERNAL_INFORMATION,
        },
      },
      {
        path: "/admin/thu-thap-thong-tin/tien-do-thu-thap-thong-tin",
        name: "manager.tienDoThuThapThongTin",
        component: () =>
          import("@/views/manager/pages/common_info/info/list/index.vue"),
        meta: {
          pageTitle: "Tiến độ thu thập thông tin",
          permission: permissions.INTERNAL_INFORMATION,
        },
      },
      {
        path: "/admin/thu-thap-thong-tin/tien-do-thu-thap-thong-tin/chi-tiet/:id",
        name: "manager.tienDoThuThapThongTin.detail",
        component: () =>
          import("@/views/manager/pages/common_info/info/detail/index.vue"),
        meta: {
          pageTitle: "Chi tiết tiến độ thu thập thông tin",
          breadcrumbs: [
            {
              title: "Danh sách tiến độ thu thập thông tin",
              routeName: "manager.tienDoThuThapThongTin",
            },
            {
              title: "Chi tiết tiến độ thu thập thông tin",
              routeName: "manager.tienDoThuThapThongTin.detail",
            },
          ],
          permission: permissions.INTERNAL_INFORMATION,
        },
      },
      {
        path: "/admin/dieu-hanh-noi-bo/van-ban-noi-bo",
        name: "manager.internalOperationsManagement.internalDocument",
        component: () =>
          import(
            "@/views/manager/pages/internal-operations-management/internal-documents/list/index.vue"
          ),
        meta: {
          pageTitle: "Văn bản nội bộ",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.internalDocument.add",
            permission: permissions.INTERNAL_OPERATION_ADD,
          },
          permission: permissions.INTERNAL_OPERATION_ACCESS,
        },
      },
      {
        path: "/admin/dieu-hanh-noi-bo/van-ban-noi-bo/chi-tiet/:id",
        name: "manager.internalOperationsManagement.internalDocument.detail",
        component: () =>
          import(
            "@/views/manager/pages/internal-operations-management/internal-documents/detail/index.vue"
          ),
        meta: {
          pageTitle: "Chi tiết văn bản nội bộ",
          breadcrumbs: [
            {
              title: "Danh sách văn bản nội bộ",
              routeName:
                "manager.internalOperationsManagement.internalDocument",
            },
            {
              title: "Chi tiết văn bản nội bộ",
              routeName:
                "manager.internalOperationsManagement.internalDocument.detail",
            },
          ],
          permission: permissions.INTERNAL_OPERATION_ACCESS,
        },
      },
      {
        path: "/admin/dieu-hanh-noi-bo/van-ban-noi-bo/them",
        name: "manager.internalDocument.add",
        component: () =>
          import(
            "@/views/manager/pages/internal-operations-management/internal-documents/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Tạo văn bản",
          breadcrumbs: [
            {
              title: "Danh sách văn bản nội bộ",
              routeName:
                "manager.internalOperationsManagement.internalDocument",
            },
            {
              title: "Tạo văn bản nội bộ",
              routeName: "manager.internalDocument.add",
            },
          ],
          permission: permissions.INTERNAL_OPERATION_ADD,
        },
      },
      {
        path: "/admin/dieu-hanh-noi-bo/van-ban-noi-bo/chinh-sua/:id",
        name: "manager.internalDocument.edit",
        component: () =>
          import(
            "@/views/manager/pages/internal-operations-management/internal-documents/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Cập nhật văn bản nội bộ",
          breadcrumbs: [
            {
              title: "Danh sách văn bản nội bộ",
              routeName:
                "manager.internalOperationsManagement.internalDocument",
            },
            {
              title: "Cập nhật văn bản nội bộ",
              routeName: "manager.internalDocument.edit",
            },
          ],
          permission: permissions.INTERNAL_OPERATION_EDIT,
        },
      },
      {
        path: "/admin/nhom-nguoi-dung",
        name: "manager.userGroup",
        component: () =>
          import("@/views/manager/pages/user-group/list/index.vue"),
        meta: {
          pageTitle: "Danh sách nhóm người dùng",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.userGroup.add",
            permission: permissions.MANAGER_AND_ROLE_ADD,
          },
          breadcrumbs: [],
          permission: permissions.MANAGER_AND_ROLE_ACCESS,
        },
      },
      {
        path: "/admin/nhom-nguoi-dung/add",
        name: "manager.userGroup.add",
        component: () =>
          import("@/views/manager/pages/user-group/add_edit/index.vue"),
        meta: {
          pageTitle: "Tạo nhóm người dùng",
          breadcrumbs: [
            {
              title: "Danh sách nhóm người dùng",
              routeName: "manager.userGroup",
            },
            {
              title: "Tạo nhóm người dùng",
              routeName: "manager.userGroup.add",
            },
          ],
          permission: permissions.MANAGER_AND_ROLE_ADD,
        },
      },
      {
        path: "/admin/nhom-nguoi-dung/edit/:id",
        name: "manager.userGroup.edit",
        component: () =>
          import("@/views/manager/pages/user-group/add_edit/index.vue"),
        meta: {
          pageTitle: "Cập nhật nhóm người dùng",
          breadcrumbs: [
            {
              title: "Danh sách nhóm người dùng",
              routeName: "manager.userGroup",
            },
            {
              title: "Cập nhật nhóm người dùng",
              routeName: "manager.userGroup.edit",
            },
          ],
          permission: permissions.MANAGER_AND_ROLE_EDIT,
        },
      },
      {
        path: "/admin/nhom-nguoi-dung/detail/:id",
        name: "manager.userGroup.detail",
        component: () =>
          import("@/views/manager/pages/user-group/detail/index.vue"),
        meta: {
          pageTitle: "Chi tiết nhóm người dùng",
          breadcrumbs: [
            {
              title: "Danh sách nhóm người dùng",
              routeName: "manager.userGroup",
            },
            {
              title: "Chi tiết nhóm người dùng",
              routeName: "manager.userGroup.detail",
            },
          ],
          permission: permissions.MANAGER_AND_ROLE_ACCESS,
        },
      },
      {
        path: "/admin/phan-quyen",
        name: "manager.permission",
        component: () =>
          import("@/views/manager/pages/permission/list/index.vue"),
        meta: {
          pageTitle: "Quản lý phân quyền",
          // TODO: Change UI
          // btnNew: {
          //   text: "Tạo mới",
          //   routeName: "manager.permission.add",
          // },
          breadcrumbs: [],
          permission: permissions.MANAGER_AND_ROLE_ACCESS,
        },
      },

      // TODO: using modal instead
      // {
      //   path: "/admin/phan-quyen/add",
      //   name: "manager.permission.add",
      //   component: () =>
      //     import("@/views/manager/pages/permission/add_edit/index.vue"),
      //   meta: {
      //     pageTitle: "Tạo quyền",
      //     breadcrumbs: [
      //       {
      //         title: "Danh sách quyền",
      //         routeName: "manager.permission",
      //       },
      //       {
      //         title: "Tạo quyền",
      //         routeName: "manager.permission.add",
      //       },
      //     ],
      //   },
      // },
      // {
      //   path: "/admin/phan-quyen/edit/:id",
      //   name: "manager.permission.edit",
      //   component: () =>
      //     import("@/views/manager/pages/permission/add_edit/index.vue"),
      //   meta: {
      //     pageTitle: "Cập nhật quyền",
      //     breadcrumbs: [
      //       {
      //         title: "Danh sách quyền",
      //         routeName: "manager.permission",
      //       },
      //       {
      //         title: "Cập nhật quyền",
      //         routeName: "manager.permission.edit",
      //       },
      //     ],
      //   },
      // },
      {
        path: "/admin/phan-quyen/detail/:id",
        name: "manager.permission.detail",
        component: () =>
          import("@/views/manager/pages/permission/detail/index.vue"),
        meta: {
          pageTitle: "Chi tiết quyền",
          breadcrumbs: [
            {
              title: "Danh sách quyền",
              routeName: "manager.permission",
            },
            {
              title: "Chi tiết quyền",
              routeName: "manager.permission.detail",
            },
          ],
          permission: permissions.MANAGER_AND_ROLE_ACCESS,
        },
      },
      {
        path: "/admin/noi-dung/news",
        name: "manager.content.news",
        component: () =>
          import("@/views/manager/pages/content/news/list/index.vue"),
        meta: {
          pageTitle: "Tin Tức",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.content.news.add",
            permission: permissions.CONTENT_ADD,
          },
          permission: permissions.CONTENT_ACCESS,
        },
      },
      {
        path: "/admin/noi-dung/news/add",
        name: "manager.content.news.add",
        component: () =>
          import("@/views/manager/pages/content/news/add_edit/index.vue"),
        meta: {
          pageTitle: "Tạo tin tức",
          breadcrumbs: [
            {
              title: "Danh sách tin tức",
              routeName: "manager.content.news",
            },
            {
              title: "Tạo tin tức",
              routeName: "manager.content.news.add",
            },
          ],
          permission: permissions.CONTENT_ADD,
        },
      },
      {
        path: "/admin/noi-dung/news/edit/:id",
        name: "manager.content.news.edit",
        component: () =>
          import("@/views/manager/pages/content/news/add_edit/index.vue"),
        meta: {
          pageTitle: "Cập nhật tin tức",
          breadcrumbs: [
            {
              title: "Danh sách tin tức",
              routeName: "manager.content.news",
            },
            {
              title: "Cập nhật tin tức",
              routeName: "manager.content.news.edit",
            },
          ],
          permission: permissions.CONTENT_EDIT,
        },
      },
      {
        path: "/admin/noi-dung/news/detail/:id",
        name: "manager.content.news.detail",
        component: () =>
          import("@/views/manager/pages/content/news/detail/index.vue"),
        meta: {
          pageTitle: "Chi tiết tin tức",
          breadcrumbs: [
            {
              title: "Danh sách tin tức",
              routeName: "manager.content.news",
            },
            {
              title: "Chi tiết tin tức",
              routeName: "manager.content.news.detail",
            },
          ],
          permission: permissions.CONTENT_ACCESS,
        },
      },
      {
        path: "/admin/noi-dung/videos",
        name: "manager.content.videos",
        component: () =>
          import("@/views/manager/pages/content/videos/list/index.vue"),
        meta: {
          pageTitle: "Videos",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.content.videos.add",
            permission: permissions.CONTENT_ADD,
          },
          permission: permissions.CONTENT_ACCESS,
        },
      },
      {
        path: "/admin/noi-dung/videos/them",
        name: "manager.content.videos.add",
        component: () =>
          import("@/views/manager/pages/content/videos/add_edit/index.vue"),
        meta: {
          pageTitle: "Tạo video",
          breadcrumbs: [
            {
              title: "Danh sách video",
              routeName: "manager.content.videos",
            },
            {
              title: "Tạo video",
              routeName: "manager.content.videos.add",
            },
          ],
          permission: permissions.CONTENT_ADD,
        },
      },
      {
        path: "/admin/noi-dung/videos/chinh-sua/:id",
        name: "manager.content.videos.edit",
        component: () =>
          import("@/views/manager/pages/content/videos/add_edit/index.vue"),
        meta: {
          pageTitle: "Cập nhật video",
          breadcrumbs: [
            {
              title: "Danh sách video",
              routeName: "manager.content.videos",
            },
            {
              title: "Cập nhật video",
              routeName: "manager.content.videos.edit",
            },
          ],
          permission: permissions.CONTENT_EDIT,
        },
      },
      {
        path: "/admin/noi-dung/video/chi-tiet/:id",
        name: "manager.content.videos.detail",
        component: () =>
          import("@/views/manager/pages/content/videos/detail/index.vue"),
        meta: {
          pageTitle: "Chi tiết Video",
          breadcrumbs: [
            {
              title: "Danh sách video",
              routeName: "manager.content.videos",
            },
            {
              title: "Chi tiết video",
              routeName: "manager.content.videos.detail",
            },
          ],
          permission: permissions.CONTENT_ACCESS,
        },
      },
      {
        path: "/admin/van-ban/linh-vuc-van-ban",
        name: "manager.document.field-documents",
        component: () =>
          import(
            "@/views/manager/pages/document/field-documents/list/index.vue"
          ),
        meta: {
          pageTitle: "Lĩnh vực văn bản",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.document.field-documents.add",
            permission: permissions.DOCUMENT_ADD,
          },
          permission: permissions.DOCUMENT_ACCESS,
        },
      },
      {
        path: "/admin/van-ban/linh-vuc-van-ban/add",
        name: "manager.document.field-documents.add",
        component: () =>
          import(
            "@/views/manager/pages/document/field-documents/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Tạo lĩnh vực văn bản",
          breadcrumbs: [
            {
              title: "Danh sách lĩnh vực văn bản",
              routeName: "manager.document.field-documents",
            },
            {
              title: "Tạo lĩnh vực văn bản",
              routeName: "manager.document.field-documents.add",
            },
          ],
          permission: permissions.DOCUMENT_ADD,
        },
      },
      {
        path: "/admin/van-ban/linh-vuc-van-ban/edit/:id",
        name: "manager.document.field-documents.edit",
        component: () =>
          import(
            "@/views/manager/pages/document/field-documents/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Cập nhật lĩnh vực văn bản",
          breadcrumbs: [
            {
              title: "Danh sách lĩnh vực văn bản",
              routeName: "manager.document.field-documents",
            },
            {
              title: "Cập nhật lĩnh vực văn bản",
              routeName: "manager.document.field-documents.edit",
            },
          ],
          permission: permissions.DOCUMENT_EDIT,
        },
      },
      {
        path: "/admin/van-ban/linh-vuc-van-ban/detail/:id",
        name: "manager.document.field-documents.detail",
        component: () =>
          import(
            "@/views/manager/pages/document/field-documents/detail/index.vue"
          ),
        meta: {
          pageTitle: "Chi tiết lĩnh vực văn bản",
          breadcrumbs: [
            {
              title: "Danh sách lĩnh vực văn bản",
              routeName: "manager.document.field-documents",
            },
            {
              title: "Chi tiết lĩnh vực văn bản",
              routeName: "manager.document.field-documents.detail",
            },
          ],
          permission: permissions.DOCUMENT_ACCESS,
        },
      },
      {
        path: "/admin/van-ban/co-quan-ban-hanh-van-ban",
        name: "manager.document.agency-issued-documents",
        component: () =>
          import(
            "@/views/manager/pages/document/agency-issued-documents/list/index.vue"
          ),
        meta: {
          pageTitle: "Cơ quan ban hành văn bản",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.document.agency-issued-documents.add",
            permission: permissions.DOCUMENT_ADD,
          },
          permission: permissions.DOCUMENT_ACCESS,
        },
      },
      {
        path: "/admin/van-ban/co-quan-ban-hanh-van-ban/add",
        name: "manager.document.agency-issued-documents.add",
        component: () =>
          import(
            "@/views/manager/pages/document/agency-issued-documents/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Tạo cơ quan ban hành văn bản",
          breadcrumbs: [
            {
              title: "Danh sách cơ quan ban hành văn bản",
              routeName: "manager.document.agency-issued-documents",
            },
            {
              title: "Tạo cơ quan ban hành văn bản",
              routeName: "manager.document.agency-issued-documents.add",
            },
          ],
          permission: permissions.DOCUMENT_ADD,
        },
      },
      {
        path: "/admin/van-ban/co-quan-ban-hanh-van-ban/edit/:id",
        name: "manager.document.agency-issued-documents.edit",
        component: () =>
          import(
            "@/views/manager/pages/document/agency-issued-documents/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Cập nhật cơ quan ban hành văn bản",
          breadcrumbs: [
            {
              title: "Danh sách cơ quan ban hành văn bản",
              routeName: "manager.document.agency-issued-documents",
            },
            {
              title: "Cập nhật cơ quan ban hành văn bản",
              routeName: "manager.document.agency-issued-documents.edit",
            },
          ],
          permission: permissions.DOCUMENT_EDIT,
        },
      },
      {
        path: "/admin/van-ban/co-quan-ban-hanh-van-ban/detail/:id",
        name: "manager.document.agency-issued-documents.detail",
        component: () =>
          import(
            "@/views/manager/pages/document/agency-issued-documents/detail/index.vue"
          ),
        meta: {
          pageTitle: "Chi tiết cơ quan ban hành văn bản",
          breadcrumbs: [
            {
              title: "Danh sách cơ quan ban hành văn bản",
              routeName: "manager.document.agency-issued-documents",
            },
            {
              title: "Chi tiết cơ quan ban hành văn bản",
              routeName: "manager.document.agency-issued-documents.detail",
            },
          ],
          permission: permissions.DOCUMENT_ACCESS,
        },
      },
      {
        path: "/admin/van-ban/loai-van-ban",
        name: "manager.document.type-documents",
        component: () =>
          import(
            "@/views/manager/pages/document/type-documents/list/index.vue"
          ),
        meta: {
          pageTitle: "Loại văn bản",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.document.type-documents.add",
            permission: permissions.DOCUMENT_ADD,
          },
          permission: permissions.DOCUMENT_ACCESS,
        },
      },
      {
        path: "/admin/van-ban/loai-van-ban/van-ban/van-ban/them",
        name: "manager.document.type-documents.add",
        component: () =>
          import(
            "@/views/manager/pages/document/type-documents/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Tạo loại văn bản",
          breadcrumbs: [
            {
              title: "Danh sách loại văn bản",
              routeName: "manager.document.type-documents",
            },
            {
              title: "Tạo loại văn bản",
              routeName: "manager.document.type-documents.add",
            },
          ],
          permission: permissions.DOCUMENT_ADD,
        },
      },
      {
        path: "/admin/van-ban/loai-van-ban/edit/:id",
        name: "manager.document.type-documents.edit",
        component: () =>
          import(
            "@/views/manager/pages/document/type-documents/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Cập nhật loại văn bản",
          breadcrumbs: [
            {
              title: "Danh sách loại văn bản",
              routeName: "manager.document.type-documents",
            },
            {
              title: "Cập nhật loại văn bản",
              routeName: "manager.document.type-documents.edit",
            },
          ],
          permission: permissions.DOCUMENT_EDIT,
        },
      },
      {
        path: "/admin/van-ban/loai-van-ban/detail/:id",
        name: "manager.document.type-documents.detail",
        component: () =>
          import(
            "@/views/manager/pages/document/type-documents/detail/index.vue"
          ),
        meta: {
          pageTitle: "Chi tiết loại văn bản",
          breadcrumbs: [
            {
              title: "Danh sách loại văn bản",
              routeName: "manager.document.type-documents",
            },
            {
              title: "Chi tiết loại văn bản",
              routeName: "manager.document.type-documents.detail",
            },
          ],
          permission: permissions.DOCUMENT_ACCESS,
        },
      },
      {
        path: "/admin/van-ban/van-ban",
        name: "manager.document.documents",
        component: () =>
          import("@/views/manager/pages/document/documents/list/index.vue"),
        meta: {
          pageTitle: "Văn bản",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.document.documents.add",
            permission: permissions.DOCUMENT_ADD,
          },
          permission: permissions.DOCUMENT_ACCESS,
        },
      },
      {
        path: "/admin/van-ban/van-ban/them",
        name: "manager.document.documents.add",
        component: () =>
          import("@/views/manager/pages/document/documents/add_edit/index.vue"),
        meta: {
          pageTitle: "Tạo văn bản",
          breadcrumbs: [
            {
              title: "Danh sách văn bản",
              routeName: "manager.document.documents",
            },
            {
              title: "Tạo văn bản",
              routeName: "manager.document.documents.add",
            },
          ],
          permission: permissions.DOCUMENT_ADD,
        },
      },
      {
        path: "/admin/van-ban/van-ban/chinh-sua/:id",
        name: "manager.document.documents.edit",
        component: () =>
          import("@/views/manager/pages/document/documents/add_edit/index.vue"),
        meta: {
          pageTitle: "Cập nhật văn bản",
          breadcrumbs: [
            {
              title: "Danh sách văn bản",
              routeName: "manager.document.documents",
            },
            {
              title: "Cập nhật văn bản",
              routeName: "manager.document.documents.edit",
            },
          ],
          permission: permissions.DOCUMENT_EDIT,
        },
      },
      {
        path: "/admin/van-ban/van-ban/chi-tiet/:id",
        name: "manager.document.documents.detail",
        component: () =>
          import("@/views/manager/pages/document/documents/detail/index.vue"),
        meta: {
          pageTitle: "Chi tiết văn bản",
          breadcrumbs: [
            {
              title: "Danh sách văn bản",
              routeName: "manager.document.documents",
            },
            {
              title: "Chi tiết văn bản",
              routeName: "manager.document.documents.detail",
            },
          ],
          permission: permissions.DOCUMENT_ACCESS,
        },
      },
      {
        path: "/admin/an-pham/list_an_pham",
        name: "manager.publications.publications",
        component: () =>
          import(
            "@/views/manager/pages/publications/publications/list/index.vue"
          ),
        meta: {
          pageTitle: "Ấn phẩm",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.publications.publications.add",
            permission: permissions.PUBLICATIONS_ADD,
          },
          permission: permissions.PUBLICATIONS_ACCESS,
        },
      },
      {
        path: "/admin/an-pham/list_an_pham/add",
        name: "manager.publications.publications.add",
        component: () =>
          import(
            "@/views/manager/pages/publications/publications/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Tạo ấn phẩm",
          breadcrumbs: [
            {
              title: "Danh sách ấn phẩm",
              routeName: "manager.publications.publications",
            },
            {
              title: "Tạo ấn phẩm",
              routeName: "manager.publications.publications.add",
            },
          ],
          permission: permissions.PUBLICATIONS_ADD,
        },
      },
      {
        path: "/admin/an-pham/list_an_pham/edit/:id",
        name: "manager.publications.publications.edit",
        component: () =>
          import(
            "@/views/manager/pages/publications/publications/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Cập nhật ấn phẩm",
          breadcrumbs: [
            {
              title: "Danh sách ấn phẩm",
              routeName: "manager.publications.publications",
            },
            {
              title: "Cập nhật ấn phẩm",
              routeName: "manager.publications.publications.edit",
            },
          ],
          permission: permissions.PUBLICATIONS_EDIT,
        },
      },
      {
        path: "/admin/an-pham/list_an_pham/detail/:id",
        name: "manager.publications.publications.detail",
        component: () =>
          import(
            "@/views/manager/pages/publications/publications/detail/index.vue"
          ),
        meta: {
          pageTitle: "Chi tiết ẩn phẩm",
          breadcrumbs: [
            {
              title: "Danh sách ấn phẩm",
              routeName: "manager.publications.publications",
            },
            {
              title: "Chi tiết ấn phẩm",
              routeName: "manager.publications.publications.detail",
            },
          ],
          permission: permissions.PUBLICATIONS_ACCESS,
        },
      },
      {
        path: "/admin/thu-thap-thong-tin/che-do-bao-cao",
        name: "manager.thu-nhap-thong-tin.che-do-bao-cao",
        component: () =>
          import(
            "@/views/manager/pages/thu-nhap-thong-tin/che-do-bao-cao/list/index.vue"
          ),
        meta: {
          pageTitle: "Chế độ báo cáo",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.thu-nhap-thong-tin.che-do-bao-cao.add",
            permission: permissions.COLLECT_INFORMATION_ADD,
          },
          permission: permissions.COLLECT_INFORMATION_ACCESS,
        },
      },
      {
        path: "/admin/thu-thap-thong-tin/che-do-bao-cao/add",
        name: "manager.thu-nhap-thong-tin.che-do-bao-cao.add",
        component: () =>
          import(
            "@/views/manager/pages/thu-nhap-thong-tin/che-do-bao-cao/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Tạo chế độ báo cáo",
          breadcrumbs: [
            {
              title: "Danh sách chế độ báo cáo",
              routeName: "manager.thu-nhap-thong-tin.che-do-bao-cao",
            },
            {
              title: "Tạo chế độ báo cáo",
              routeName: "manager.thu-nhap-thong-tin.che-do-bao-cao.add",
            },
          ],
          permission: permissions.COLLECT_INFORMATION_ADD,
        },
      },
      {
        path: "/admin/thu-thap-thong-tin/che-do-bao-cao/edit/:id",
        name: "manager.thu-nhap-thong-tin.che-do-bao-cao.edit",
        component: () =>
          import(
            "@/views/manager/pages/thu-nhap-thong-tin/che-do-bao-cao/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Cập nhật chế độ báo cáo",
          breadcrumbs: [
            {
              title: "Danh sách chế độ báo cáo",
              routeName: "manager.thu-nhap-thong-tin.che-do-bao-cao",
            },
            {
              title: "Cập nhật chế độ báo cáo",
              routeName: "manager.thu-nhap-thong-tin.che-do-bao-cao.edit",
            },
          ],
          permission: permissions.COLLECT_INFORMATION_EDIT,
        },
      },
      {
        path: "/admin/thu-thap-thong-tin/cuoc-dieu-tra",
        name: "manager.thu-nhap-thong-tin.cuoc-dieu-tra",
        component: () =>
          import(
            "@/views/manager/pages/thu-nhap-thong-tin/cuoc-dieu-tra/list/index.vue"
          ),
        meta: {
          pageTitle: "Cuộc điều tra",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.thu-nhap-thong-tin.cuoc-dieu-tra.add",
            permission: permissions.COLLECT_INFORMATION_ADD,
          },
          permission: permissions.COLLECT_INFORMATION_ACCESS,
        },
      },
      {
        path: "/admin/thu-thap-thong-tin/cuoc-dieu-tra/add",
        name: "manager.thu-nhap-thong-tin.cuoc-dieu-tra.add",
        component: () =>
          import(
            "@/views/manager/pages/thu-nhap-thong-tin/cuoc-dieu-tra/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Tạo cuộc điều tra",
          breadcrumbs: [
            {
              title: "Cuộc điều tra",
              routeName: "manager.thu-nhap-thong-tin.cuoc-dieu-tra",
            },
            {
              title: "Tạo cuộc điều tra",
              routeName: "manager.thu-nhap-thong-tin.cuoc-dieu-tra.add",
            },
          ],
          permission: permissions.COLLECT_INFORMATION_ADD,
        },
      },
      {
        path: "/admin/thu-thap-thong-tin/cuoc-dieu-tra/edit/:id",
        name: "manager.thu-nhap-thong-tin.cuoc-dieu-tra.edit",
        component: () =>
          import(
            "@/views/manager/pages/thu-nhap-thong-tin/cuoc-dieu-tra/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Cập nhật cuộc điều tra",
          breadcrumbs: [
            {
              title: "Cuộc điều tra",
              routeName: "manager.thu-nhap-thong-tin.cuoc-dieu-tra",
            },
            {
              title: "Cập nhật cuộc điều tra",
              routeName: "manager.thu-nhap-thong-tin.cuoc-dieu-tra.edit",
            },
          ],
          permission: permissions.COLLECT_INFORMATION_EDIT,
        },
      },
      {
        path: "/admin/an-pham/bao-cao-ktxh",
        name: "manager.publications.report-ktxhs",
        component: () =>
          import(
            "@/views/manager/pages/publications/report-ktxhs/list/index.vue"
          ),
        meta: {
          pageTitle: "Báo cáo KT-XH",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.publications.report-ktxhs.add",
            permission: permissions.PUBLICATIONS_ADD,
          },
          permission: permissions.PUBLICATIONS_ACCESS,
        },
      },
      {
        path: "/admin/an-pham/bao-cao-ktxh/add",
        name: "manager.publications.report-ktxhs.add",
        component: () =>
          import(
            "@/views/manager/pages/publications/report-ktxhs/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Tạo báo cáo KT-XH",
          breadcrumbs: [
            {
              title: "Danh sách báo cáo KT-XH",
              routeName: "manager.publications.report-ktxhs",
            },
            {
              title: "Tạo báo cáo KT-XH",
              routeName: "manager.publications.report-ktxhs.add",
            },
          ],
          permission: permissions.PUBLICATIONS_ADD,
        },
      },
      {
        path: "/admin/an-pham/bao-cao-ktxh/edit/:id",
        name: "manager.publications.report-ktxhs.edit",
        component: () =>
          import(
            "@/views/manager/pages/publications/report-ktxhs/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Cập nhật báo cáo KT-XH",
          breadcrumbs: [
            {
              title: "Danh sách báo cáo KT-XH",
              routeName: "manager.publications.report-ktxhs",
            },
            {
              title: "Cập nhật báo cáo KT-XH",
              routeName: "manager.publications.report-ktxhs.edit",
            },
          ],
          permission: permissions.PUBLICATIONS_EDIT,
        },
      },
      {
        path: "/admin/nien-giam/danh-sach-nien-giam",
        name: "manager.yearbook.yearbook",
        component: () =>
          import("@/views/manager/pages/yearbook/yearbook/list/index.vue"),
        meta: {
          pageTitle: "Niên giám",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.yearbook.yearbook.add",
            permission: permissions.YEARBOOK_ADD,
          },
          permission: permissions.YEARBOOK_ACCESS,
        },
      },
      {
        path: "/admin/nien-giam/danh-sach-nien-giam/them",
        name: "manager.yearbook.yearbook.add",
        component: () =>
          import("@/views/manager/pages/yearbook/yearbook/add_edit/index.vue"),
        meta: {
          pageTitle: "Tạo niên giám",
          breadcrumbs: [
            {
              title: "Danh sách niên giám",
              routeName: "manager.yearbook.yearbook",
            },
            {
              title: "Tạo niên giám",
              routeName: "manager.yearbook.yearbook.add",
            },
          ],
          permission: permissions.YEARBOOK_ADD,
        },
      },
      {
        path: "/admin/nien-giam/danh-sach-nien-giam/chinh-sua/:id",
        name: "manager.yearbook.yearbook.edit",
        component: () =>
          import("@/views/manager/pages/yearbook/yearbook/add_edit/index.vue"),
        meta: {
          pageTitle: "Cập nhật niên giám",
          breadcrumbs: [
            {
              title: "Danh sách niên giám",
              routeName: "manager.yearbook.yearbook",
            },
            {
              title: "Cập nhật niên giám",
              routeName: "manager.yearbook.yearbook.edit",
            },
          ],
          permission: permissions.YEARBOOK_EDIT,
        },
      },
      {
        path: "/admin/nien-giam/danh-muc-chi-tieu-nien-giam",
        name: "manager.yearbook.category-yearbook",
        component: () =>
          import(
            "@/views/manager/pages/yearbook/category-yearbook/list/index.vue"
          ),
        meta: {
          pageTitle: "Danh mục chỉ tiêu niên giám",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.yearbook.category-yearbook.add",
            permission: permissions.YEARBOOK_ADD,
          },
          permission: permissions.YEARBOOK_ACCESS,
        },
      },
      {
        path: "/admin/nien-giam/danh-muc-chi-tieu-nien-giam/them",
        name: "manager.yearbook.category-yearbook.add",
        component: () =>
          import(
            "@/views/manager/pages/yearbook/category-yearbook/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Tạo danh mục chỉ tiêu niên giám",
          breadcrumbs: [
            {
              title: "Danh sách danh mục chỉ tiêu niên giám",
              routeName: "manager.yearbook.category-yearbook",
            },
            {
              title: "Tạo danh mục chỉ tiêu niên giám",
              routeName: "manager.yearbook.category-yearbook.add",
            },
          ],
          permission: permissions.YEARBOOK_ADD,
        },
      },
      {
        path: "/admin/nien-giam/danh-muc-chi-tieu-nien-giam/chinh-sua/:id",
        name: "manager.yearbook.category-yearbook.edit",
        component: () =>
          import(
            "@/views/manager/pages/yearbook/category-yearbook/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Cập nhật danh mục chỉ tiêu niên giám",
          breadcrumbs: [
            {
              title: "Danh sách danh mục chỉ tiêu niên giám",
              routeName: "manager.yearbook.category-yearbook",
            },
            {
              title: "Cập nhật danh mục chỉ tiêu niên giám",
              routeName: "manager.yearbook.category-yearbook.edit",
            },
          ],
          permission: permissions.YEARBOOK_EDIT,
        },
      },
      // {
      //   path: "/admin/nien-giam/chi-tieu-nien-giam-tk",
      //   name: "manager.yearbook.target-yearbooks",
      //   component: () =>
      //     import(
      //       "@/views/manager/pages/yearbook/target-yearbooks/list/index.vue"
      //     ),
      //   meta: {
      //     pageTitle: "Chỉ tiêu niên giám thống kê",
      //     btnNew: {
      //       text: "Tạo mới",
      //       routeName: "manager.yearbook.target-yearbooks.add",
      //     },
      //   },
      // },
      // {
      //   path: "/admin/nien-giam/chi-tieu-nien-giam-tk/them",
      //   name: "manager.yearbook.target-yearbooks.add",
      //   component: () =>
      //     import(
      //       "@/views/manager/pages/yearbook/target-yearbooks/add_edit/index.vue"
      //     ),
      //   meta: {
      //     pageTitle: "Tạo chỉ tiêu niên giám thống kê",
      //     breadcrumbs: [
      //       {
      //         title: "Danh sách chỉ tiêu niên giám thống kê",
      //         routeName: "manager.yearbook.target-yearbooks",
      //       },
      //       {
      //         title: "Tạo chỉ tiêu niên giám thống kê",
      //         routeName: "manager.yearbook.target-yearbooks.add",
      //       },
      //     ],
      //   },
      // },
      // {
      //   path: "/admin/nien-giam/chi-tieu-nien-giam-tk/chinh-sua/:id",
      //   name: "manager.yearbook.target-yearbooks.edit",
      //   component: () =>
      //     import(
      //       "@/views/manager/pages/yearbook/target-yearbooks/add_edit/index.vue"
      //     ),
      //   meta: {
      //     pageTitle: "Cập nhật chỉ tiêu niên giám thống kê",
      //     breadcrumbs: [
      //       {
      //         title: "Danh sách chỉ tiêu niên giám thống kê",
      //         routeName: "manager.yearbook.target-yearbooks",
      //       },
      //       {
      //         title: "Cập nhật chỉ tiêu niên giám thống kê",
      //         routeName: "manager.yearbook.target-yearbooks.edit",
      //       },
      //     ],
      //   },
      // },
      {
        path: "/admin/so-lieu-thong-ke/lich-pho-bien",
        name: "manager.stats.lichphobiens.list",
        component: () =>
          import("@/views/manager/pages/stats/lichphobiens/list/index.vue"),
        meta: {
          pageTitle: "Lịch phổ biến",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.stats.lichphobiens.add",
            permission: permissions.STATISTICS_ADD,
          },
          permission: permissions.STATISTICS_ACCESS,
        },
      },
      {
        path: "/admin/so-lieu-thong-ke/lich-pho-bien/them",
        name: "manager.stats.lichphobiens.add",
        component: () =>
          import("@/views/manager/pages/stats/lichphobiens/add_edit/index.vue"),
        meta: {
          pageTitle: "Tạo lịch phổ biến",
          breadcrumbs: [
            {
              title: "Danh sách lịch phổ biến",
              routeName: "manager.stats.lichphobiens.list",
            },
            {
              title: "Tạo lịch phổ biến",
              routeName: "manager.stats.lichphobiens.add",
            },
          ],
          permission: permissions.STATISTICS_ADD,
        },
      },
      {
        path: "/admin/so-lieu-thong-ke/lich-pho-bien/chinh-sua/:id",
        name: "manager.stats.lichphobiens.edit",
        component: () =>
          import("@/views/manager/pages/stats/lichphobiens/add_edit/index.vue"),
        meta: {
          pageTitle: "Cập nhật lịch phổ biến",
          breadcrumbs: [
            {
              title: "Danh sách lịch phổ biến",
              routeName: "manager.stats.lichphobiens.list",
            },
            {
              title: "Cập nhật lịch phổ biến",
              routeName: "manager.stats.lichphobiens.edit",
            },
          ],
          permission: permissions.STATISTICS_EDIT,
        },
      },
      {
        path: "/admin/so-lieu-thong-ke/chi-tieu-thong-ke",
        name: "manager.stats.chitieuthongkes.list",
        component: () =>
          import("@/views/manager/pages/stats/chitieuthongkes/list/index.vue"),
        meta: {
          pageTitle: "Chỉ tiêu thống kê",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.stats.chitieuthongkes.add",
            permission: permissions.STATISTICS_ADD,
          },
          permission: permissions.STATISTICS_ACCESS,
        },
      },
      {
        path: "/admin/so-lieu-thong-ke/chi-tieu-thong-ke/them",
        name: "manager.stats.chitieuthongkes.add",
        component: () =>
          import(
            "@/views/manager/pages/stats/chitieuthongkes/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Tạo chỉ tiêu thống kê",
          breadcrumbs: [
            {
              title: "Danh sách chỉ tiêu thống kê",
              routeName: "manager.stats.chitieuthongkes.list",
            },
            {
              title: "Tạo chỉ tiêu thống kê",
              routeName: "manager.stats.chitieuthongkes.add",
            },
          ],
          permission: permissions.STATISTICS_ADD,
        },
      },
      {
        path: "/admin/so-lieu-thong-ke/chi-tieu-thong-ke/chinh-sua/:id",
        name: "manager.stats.chitieuthongkes.edit",
        component: () =>
          import(
            "@/views/manager/pages/stats/chitieuthongkes/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Cập nhật chỉ tiêu thống kê",
          breadcrumbs: [
            {
              title: "Danh sách chỉ tiêu thống kê",
              routeName: "manager.stats.chitieuthongkes.list",
            },
            {
              title: "Cập nhật chỉ tiêu thống kê",
              routeName: "manager.stats.chitieuthongkes.edit",
            },
          ],
          permission: permissions.STATISTICS_EDIT,
        },
      },
      {
        path: "/admin/so-lieu-thong-ke/du-lieu-chi-tieu",
        name: "manager.stats.dulieuchitieu.list",
        component: () =>
          import("@/views/manager/pages/stats/dulieuchitieu/list/index.vue"),
        meta: {
          pageTitle: "Dữ liệu Chỉ tiêu",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.stats.dulieuchitieu.add",
            permission: permissions.STATISTICS_ADD,
          },
          permission: permissions.STATISTICS_ACCESS,
        },
      },
      {
        path: "/admin/so-lieu-thong-ke/du-lieu-chi-tieu/them",
        name: "manager.stats.dulieuchitieu.add",
        component: () =>
          import(
            "@/views/manager/pages/stats/dulieuchitieu/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Tạo dữ liệu chỉ tiêu",
          breadcrumbs: [
            {
              title: "Danh sách dữ liệu chỉ tiêu",
              routeName: "manager.stats.dulieuchitieu.list",
            },
            {
              title: "Tạo dữ liệu chỉ tiêu",
              routeName: "manager.stats.dulieuchitieu.add",
            },
          ],
          permission: permissions.STATISTICS_ADD,
        },
      },
      {
        path: "/admin/so-lieu-thong-ke/du-lieu-chi-tieu/chinh-sua/:year_month",
        name: "manager.stats.dulieuchitieu.edit",
        component: () =>
          import(
            "@/views/manager/pages/stats/dulieuchitieu/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Cập nhật dữ liệu chỉ tiêu",
          breadcrumbs: [
            {
              title: "Danh sách dữ liệu chỉ tiêu",
              routeName: "manager.stats.dulieuchitieu.list",
            },
            {
              title: "Cập nhật dữ liệu chỉ tiêu",
              routeName: "manager.stats.dulieuchitieu.edit",
            },
          ],
          permission: permissions.STATISTICS_EDIT,
        },
      },
      {
        path: "/admin/so-lieu-thong-ke/bao-cao-so-lieu-thong-ke",
        name: "manager.stats.baocaosltk.list",
        component: () =>
          import("@/views/manager/pages/stats/baocaosltk/list/index.vue"),
        meta: {
          pageTitle: "Báo cáo số liệu thống kê",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.stats.baocaosltk.add",
            permission: permissions.STATISTICS_ADD,
          },
          permission: permissions.STATISTICS_ACCESS,
        },
      },
      {
        path: "/admin/so-lieu-thong-ke/bao-cao-so-lieu-thong-ke/them",
        name: "manager.stats.baocaosltk.add",
        component: () =>
          import("@/views/manager/pages/stats/baocaosltk/add_edit/index.vue"),
        meta: {
          pageTitle: "Tạo báo cáo số liệu thống kê",
          breadcrumbs: [
            {
              title: "Danh sách báo cáo số liệu thống kê",
              routeName: "manager.stats.baocaosltk.list",
            },
            {
              title: "Tạo báo cáo số liệu thống kê",
              routeName: "manager.stats.baocaosltk.add",
            },
          ],
          permission: permissions.STATISTICS_ADD,
        },
      },
      {
        path: "/admin/so-lieu-thong-ke/bao-cao-so-lieu-thong-ke/chinh-sua/:id",
        name: "manager.stats.baocaosltk.edit",
        component: () =>
          import("@/views/manager/pages/stats/baocaosltk/add_edit/index.vue"),
        meta: {
          pageTitle: "Cập nhật báo cáo số liệu thống kê",
          breadcrumbs: [
            {
              title: "Danh sách báo cáo số liệu thống kê",
              routeName: "manager.stats.baocaosltk.list",
            },
            {
              title: "Cập nhật báo cáo số liệu thống kê",
              routeName: "manager.stats.baocaosltk.edit",
            },
          ],
          permission: permissions.STATISTICS_EDIT,
        },
      },
      {
        path: "/admin/dieu-hanh-noi-bo/thong-bao",
        name: "manager.internal.notification.list",
        component: () =>
          import("@/views/manager/pages/internal/notification/list/index.vue"),
        meta: {
          pageTitle: "Thông báo nội bộ",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.internal.notification.add",
            permission: permissions.INTERNAL_OPERATION_ADD,
          },
          permission: permissions.INTERNAL_OPERATION_ACCESS,
        },
      },
      {
        path: "/admin/dieu-hanh-noi-bo/thong-bao/them",
        name: "manager.internal.notification.add",
        component: () =>
          import(
            "@/views/manager/pages/internal/notification/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Tạo thông báo nội bộ",
          breadcrumbs: [
            {
              title: "Danh sách thông báo nội bộ",
              routeName: "manager.internal.notification.list",
            },
            {
              title: "Tạo thông báo nội bộ",
              routeName: "manager.internal.notification.add",
            },
          ],
          permission: permissions.INTERNAL_OPERATION_ACCESS,
        },
      },
      {
        path: "/admin/dieu-hanh-noi-bo/thong-bao/chinh-sua/:id",
        name: "manager.internal.notification.edit",
        component: () =>
          import(
            "@/views/manager/pages/internal/notification/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Cập nhật thông báo nội bộ",
          breadcrumbs: [
            {
              title: "Danh sách thông báo nội bộ",
              routeName: "manager.internal.notification.list",
            },
            {
              title: "Cập nhật thông báo nội bộ",
              routeName: "manager.internal.notification.edit",
            },
          ],
          permission: permissions.INTERNAL_OPERATION_EDIT,
        },
      },
      {
        path: "/admin/dang-ky-dich-vu-thong-ke",
        name: "manager.statistical.signup.list",
        component: () =>
          import("@/views/manager/pages/statistical/sign-up/list/index.vue"),
        meta: {
          pageTitle: "Đăng ký dịch vụ thống kê",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.statistical.signup.add",
            permission: permissions.STATISTICAL_SERVICE_ADD,
          },
          permission: permissions.STATISTICAL_SERVICE_ACCESS,
        },
      },
      {
        path: "/admin/dang-ky-dich-vu-thong-ke/them",
        name: "manager.statistical.signup.add",
        component: () =>
          import(
            "@/views/manager/pages/statistical/sign-up/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Tạo đăng ký dịch vụ",
          breadcrumbs: [
            {
              title: "Danh sách đăng ký dịch vụ",
              routeName: "manager.statistical.signup.list",
            },
            {
              title: "Tạo đăng ký dịch vụ",
              routeName: "manager.statistical.signup.add",
            },
          ],
          permission: permissions.STATISTICAL_SERVICE_ADD,
        },
      },
      {
        path: "/admin/dang-ky-dich-vu-thong-ke/chinh-sua/:id",
        name: "manager.statistical.signup.edit",
        component: () =>
          import(
            "@/views/manager/pages/statistical/sign-up/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Cập nhật đăng ký dịch vụ",
          breadcrumbs: [
            {
              title: "Danh sách đăng ký dịch vụ",
              routeName: "manager.statistical.signup.list",
            },
            {
              title: "Cập nhật đăng ký dịch vụ",
              routeName: "manager.statistical.signup.edit",
            },
          ],
          permission: permissions.STATISTICAL_SERVICE_EDIT,
        },
      },
      {
        path: "/admin/dang-ky-dich-vu-thong-ke/chi-tiet/:id",
        name: "manager.statistical.signup.detail",
        component: () =>
          import("@/views/manager/pages/statistical/sign-up/detail/index.vue"),
        meta: {
          pageTitle: "Chi tiết đăng ký dịch vụ",
          breadcrumbs: [
            {
              title: "Danh sách đăng ký dịch vụ",
              routeName: "manager.statistical.signup.list",
            },
            {
              title: "Chi tiết đăng ký dịch vụ",
              routeName: "manager.statistical.signup.detail",
            },
          ],
          permission: permissions.STATISTICAL_SERVICE_ACCESS,
        },
      },
      {
        path: "/admin/dich-vu-thong-ke",
        name: "manager.statistical.service.list",
        component: () =>
          import(
            "@/views/manager/pages/statistical/statistical-service/list/index.vue"
          ),
        meta: {
          pageTitle: "Dịch vụ thống kê",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.statistical.service.add",
            permission: permissions.STATISTICAL_SERVICE_ADD,
          },
          permission: permissions.STATISTICAL_SERVICE_ACCESS,
        },
      },
      {
        path: "/admin/dich-vu-thong-ke/them",
        name: "manager.statistical.service.add",
        component: () =>
          import(
            "@/views/manager/pages/statistical/statistical-service/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Tạo dịch vụ thống kê",
          breadcrumbs: [
            {
              title: "Danh sách dịch vụ thống kê",
              routeName: "manager.statistical.service.list",
            },
            {
              title: "Tạo dịch vụ thống kê",
              routeName: "manager.statistical.service.add",
            },
          ],
          permission: permissions.STATISTICAL_SERVICE_ADD,
        },
      },
      {
        path: "/admin/dich-vu-thong-ke/chinh-sua/:id",
        name: "manager.statistical.service.edit",
        component: () =>
          import(
            "@/views/manager/pages/statistical/statistical-service/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Cập nhật dịch vụ thống kê",
          breadcrumbs: [
            {
              title: "Danh sách dịch vụ thống kê",
              routeName: "manager.statistical.service.list",
            },
            {
              title: "Cập nhật dịch vụ thống kê",
              routeName: "manager.statistical.service.edit",
            },
          ],
          permission: permissions.STATISTICAL_SERVICE_EDIT,
        },
      },
      {
        path: "/admin/dich-vu-thong-ke/chi-tiet/:id",
        name: "manager.statistical.service.detail",
        component: () =>
          import(
            "@/views/manager/pages/statistical/statistical-service/detail/index.vue"
          ),
        meta: {
          pageTitle: "Chi tiết dịch vụ thống kê",
          breadcrumbs: [
            {
              title: "Danh sách dịch vụ thống kê",
              routeName: "manager.statistical.service.list",
            },
            {
              title: "Chi tiết dich vụ thống kê",
              routeName: "manager.statistical.service.detail",
            },
          ],
          permission: permissions.STATISTICAL_SERVICE_ACCESS,
        },
      },
      {
        path: "/admin/khao-sat",
        name: "manager.surveys",
        component: () => import("@/views/manager/pages/surveys/list/index.vue"),
        meta: {
          pageTitle: "Quản lý khảo sát",
          breadcrumbs: [],
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.surveys.add",
            permission: permissions.SURVEY_ADD,
          },
          permission: permissions.SURVEY_ACCESS,
        },
      },
      {
        path: "/admin/khao-sat/add",
        name: "manager.surveys.add",
        component: () =>
          import("@/views/manager/pages/surveys/add_edit/index.vue"),
        meta: {
          pageTitle: "Tạo bảng khảo sát",
          breadcrumbs: [
            {
              title: "Danh sách bảng khảo sát",
              routeName: "manager.surveys",
            },
            {
              title: "Tạo bảng khảo sát",
              routeName: "manager.surveys.add",
            },
          ],
          permission: permissions.SURVEY_ADD,
        },
      },
      {
        path: "/admin/khao-sat/edit/:id",
        name: "manager.surveys.edit",
        component: () =>
          import("@/views/manager/pages/surveys/add_edit/index.vue"),
        meta: {
          pageTitle: "Cập nhật bảng khảo sát",
          breadcrumbs: [
            {
              title: "Danh sách bảng khảo sát",
              routeName: "manager.surveys",
            },
            {
              title: "Cập nhật bảng khảo sát",
              routeName: "manager.surveys.edit",
            },
          ],
          permission: permissions.SURVEY_EDIT,
        },
      },
      {
        path: "/admin/khao-sat/:id/ket-qua",
        name: "manager.survey.result",
        component: () =>
          import("@/views/manager/pages/surveys/result/index.vue"),
        meta: {
          pageTitle: "Kết quả khảo sát",
          breadcrumbs: [],
          permission: permissions.SURVEY_ACCESS,
        },
      },
      {
        path: "/admin/gop-y",
        name: "manager.feedbacks",
        component: () =>
          import("@/views/manager/pages/feedbacks/list/index.vue"),
        meta: {
          pageTitle: "Quản lý góp ý",
          breadcrumbs: [],
          permission: permissions.FEEDBACK_ACCESS,
        },
      },
      {
        path: "/admin/gop-y/detail/:id",
        name: "manager.feedbacks.detail",
        component: () =>
          import("@/views/manager/pages/feedbacks/detail/index.vue"),
        meta: {
          pageTitle: "Chi tiết góp ý",
          breadcrumbs: [
            {
              title: "Danh sách góp ý",
              routeName: "manager.feedbacks",
            },
            {
              title: "Chi tiết góp ý",
              routeName: "manager.feedbacks.detail",
            },
          ],
          permission: permissions.FEEDBACK_ACCESS,
        },
      },
      {
        path: "/admin/hien-thi/menu",
        name: "manager.display.menu",
        component: () =>
          import("@/views/manager/pages/display/menu/list/index.vue"),
        meta: {
          pageTitle: "Menu",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.display.menu.add",
            permission: permissions.DISPLAY_ADD,
          },
          permission: permissions.DISPLAY_ACCESS,
        },
      },
      {
        path: "/admin/hien-thi/menu/add",
        name: "manager.display.menu.add",
        component: () =>
          import("@/views/manager/pages/display/menu/add_edit/index.vue"),
        meta: {
          pageTitle: "Tạo menu",
          breadcrumbs: [
            {
              title: "Danh sách menu",
              routeName: "manager.display.menu",
            },
            {
              title: "Tạo menu",
              routeName: "manager.display.menu.add",
            },
          ],
          permission: permissions.DISPLAY_ADD,
        },
      },
      {
        path: "/admin/hien-thi/menu/edit/:id",
        name: "manager.display.menu.edit",
        component: () =>
          import("@/views/manager/pages/display/menu/add_edit/index.vue"),
        meta: {
          pageTitle: "Cập nhật menu",
          breadcrumbs: [
            {
              title: "Danh sách menu",
              routeName: "manager.display.menu",
            },
            {
              title: "Cập nhật menu",
              routeName: "manager.display.menu.edit",
            },
          ],
          permission: permissions.DISPLAY_EDIT,
        },
      },
      {
        path: "/admin/hien-thi/menu/detail/:id",
        name: "manager.display.menu.detail",
        component: () =>
          import("@/views/manager/pages/display/menu/detail/index.vue"),
        meta: {
          pageTitle: "Chi tiết menu",
          breadcrumbs: [
            {
              title: "Danh sách menu",
              routeName: "manager.display.menu",
            },
            {
              title: "Chi tiết menu",
              routeName: "manager.display.menu.detail",
            },
          ],
          permission: permissions.DISPLAY_ACCESS,
        },
      },
      {
        path: "/admin/hien-thi/banner",
        name: "manager.display.banner",
        component: () =>
          import("@/views/manager/pages/display/banner/list/index.vue"),
        meta: {
          pageTitle: "Banner",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.display.banner.add",
            permission: permissions.DISPLAY_ADD,
          },
          permission: permissions.DISPLAY_ACCESS,
        },
      },
      {
        path: "/admin/hien-thi/banner/add",
        name: "manager.display.banner.add",
        component: () =>
          import("@/views/manager/pages/display/banner/add_edit/index.vue"),
        meta: {
          pageTitle: "Tạo banner",
          breadcrumbs: [
            {
              title: "Danh sách banner",
              routeName: "manager.display.banner",
            },
            {
              title: "Tạo banner",
              routeName: "manager.display.banner.add",
            },
          ],
          permission: permissions.DISPLAY_ADD,
        },
      },
      {
        path: "/admin/hien-thi/banner/edit/:id",
        name: "manager.display.banner.edit",
        component: () =>
          import("@/views/manager/pages/display/banner/add_edit/index.vue"),
        meta: {
          pageTitle: "Cập nhật banner",
          breadcrumbs: [
            {
              title: "Danh sách banner",
              routeName: "manager.display.banner",
            },
            {
              title: "Cập nhật banner",
              routeName: "manager.display.banner.edit",
            },
          ],
          permission: permissions.DISPLAY_EDIT,
        },
      },
      {
        path: "/admin/hien-thi/banner/detail/:id",
        name: "manager.display.banner.detail",
        component: () =>
          import("@/views/manager/pages/display/banner/detail/index.vue"),
        meta: {
          pageTitle: "Chi tiết banner",
          breadcrumbs: [
            {
              title: "Danh sách banner",
              routeName: "manager.display.banner",
            },
            {
              title: "Chi tiết banner",
              routeName: "manager.display.banner.detail",
            },
          ],
          permission: permissions.DISPLAY_ACCESS,
        },
      },
      {
        path: "/admin/hien-thi/dieutra_tk",
        name: "manager.display.dieutra_tk",
        component: () =>
          import("@/views/manager/pages/display/dieutra_tk/list/index.vue"),
        meta: {
          pageTitle: "Điều tra thống kê",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.display.dieutra_tk.add",
            permission: permissions.DISPLAY_ADD,
          },
          permission: permissions.DISPLAY_ACCESS,
        },
      },
      {
        path: "/admin/hien-thi/dieutra_tk/add",
        name: "manager.display.dieutra_tk.add",
        component: () =>
          import("@/views/manager/pages/display/dieutra_tk/add_edit/index.vue"),
        meta: {
          pageTitle: "Tạo Điều tra thống kê",
          breadcrumbs: [
            {
              title: "Danh sách Điều tra thống kê",
              routeName: "manager.display.dieutra_tk",
            },
            {
              title: "Tạo Điều tra thống kê",
              routeName: "manager.display.dieutra_tk.add",
            },
          ],
          permission: permissions.DISPLAY_ADD,
        },
      },
      {
        path: "/admin/hien-thi/dieutra_tk/edit/:id",
        name: "manager.display.dieutra_tk.edit",
        component: () =>
          import("@/views/manager/pages/display/dieutra_tk/add_edit/index.vue"),
        meta: {
          pageTitle: "Cập nhật điều tra thống kê",
          breadcrumbs: [
            {
              title: "Danh sách điều tra thống kê",
              routeName: "manager.display.dieutra_tk",
            },
            {
              title: "Cập nhật Điều tra thống kê",
              routeName: "manager.display.dieutra_tk.edit",
            },
          ],
          permission: permissions.DISPLAY_EDIT,
        },
      },
      {
        path: "/admin/hien-thi/dieutra_tk/detail/:id",
        name: "manager.display.dieutra_tk.detail",
        component: () =>
          import("@/views/manager/pages/display/dieutra_tk/detail/index.vue"),
        meta: {
          pageTitle: "Chi tiết Điều tra thống kê",
          breadcrumbs: [
            {
              title: "Danh sách Điều tra thống kê",
              routeName: "manager.display.dieutra_tk",
            },
            {
              title: "Chi tiết Điều tra thống kê",
              routeName: "manager.display.dieutra_tk.detail",
            },
          ],
          permission: permissions.DISPLAY_ACCESS,
        },
      },
      {
        path: "/admin/hien-thi/co-cau-to-chuc",
        name: "manager.display.organizational-structure",
        component: () =>
          import(
            "@/views/manager/pages/display/organizational-structure/list/index.vue"
          ),
        meta: {
          pageTitle: "Cơ cấu tổ chức",
          permission: permissions.DISPLAY_ACCESS,
        },
      },
      {
        path: "/admin/hien-thi/co-cau-to-chuc/lanh-dao/add",
        name: "manager.display.organizational-structure.leaders.add",
        component: () =>
          import(
            "@/views/manager/pages/display/organizational-structure/add_edit/leaders/index.vue"
          ),
        meta: {
          pageTitle: "Tạo lãnh đạo",
          breadcrumbs: [
            {
              title: "Danh sách cơ cấu tổ chức",
              routeName: "manager.display.organizational-structure",
            },
            {
              title: "Tạo lãnh đạo",
              routeName: "manager.display.organizational-structure.leaders.add",
            },
          ],
          permission: permissions.DISPLAY_ADD,
        },
      },
      {
        path: "/admin/hien-thi/co-cau-to-chuc/lanh-dao/:id",
        name: "manager.display.organizational-structure.leaders.edit",
        component: () =>
          import(
            "@/views/manager/pages/display/organizational-structure/add_edit/leaders/index.vue"
          ),
        meta: {
          pageTitle: "Cập nhật lãnh đạo",
          breadcrumbs: [
            {
              title: "Danh sách cơ cấu tổ chức",
              routeName: "manager.display.organizational-structure",
            },
            {
              title: "Cập nhật lãnh đạo",
              routeName:
                "manager.display.organizational-structure.leaders.edit",
            },
          ],
          permission: permissions.DISPLAY_EDIT,
        },
      },
      {
        path: "/admin/hien-thi/co-cau-to-chuc/phong-ban/add",
        name: "manager.display.organizational-structure.departments.add",
        component: () =>
          import(
            "@/views/manager/pages/display/organizational-structure/add_edit/departments/index.vue"
          ),
        meta: {
          pageTitle: "Tạo phòng ban",
          breadcrumbs: [
            {
              title: "Danh sách cơ cấu tổ chức",
              routeName: "manager.display.organizational-structure",
            },
            {
              title: "Tạo phòng ban",
              routeName:
                "manager.display.organizational-structure.departments.add",
            },
          ],
          permission: permissions.DISPLAY_ADD,
        },
      },
      {
        path: "/admin/hien-thi/co-cau-to-chuc/phong-ban/:id",
        name: "manager.display.organizational-structure.departments.edit",
        component: () =>
          import(
            "@/views/manager/pages/display/organizational-structure/add_edit/departments/index.vue"
          ),
        meta: {
          pageTitle: "Cập nhật phòng ban",
          breadcrumbs: [
            {
              title: "Danh sách cơ cấu tổ chức",
              routeName: "manager.display.organizational-structure",
            },
            {
              title: "Cập nhật phòng ban",
              routeName:
                "manager.display.organizational-structure.departments.edit",
            },
          ],
          permission: permissions.DISPLAY_EDIT,
        },
      },
      {
        path: "/admin/hien-thi/co-cau-to-chuc/chuc-vu/add",
        name: "manager.display.organizational-structure.positions.add",
        component: () =>
          import(
            "@/views/manager/pages/display/organizational-structure/add_edit/positions/index.vue"
          ),
        meta: {
          pageTitle: "Tạo chức vụ",
          breadcrumbs: [
            {
              title: "Danh sách cơ cấu tổ chức",
              routeName: "manager.display.organizational-structure",
            },
            {
              title: "Tạo chức vụ",
              routeName:
                "manager.display.organizational-structure.positions.add",
            },
          ],
          permission: permissions.DISPLAY_ADD,
        },
      },
      {
        path: "/admin/hien-thi/co-cau-to-chuc/chuc-vu/:id",
        name: "manager.display.organizational-structure.positions.edit",
        component: () =>
          import(
            "@/views/manager/pages/display/organizational-structure/add_edit/positions/index.vue"
          ),
        meta: {
          pageTitle: "Cập nhật chức vụ",
          breadcrumbs: [
            {
              title: "Danh sách cơ cấu tổ chức",
              routeName: "manager.display.organizational-structure",
            },
            {
              title: "Cập nhật chức vụ",
              routeName:
                "manager.display.organizational-structure.positions.edit",
            },
          ],
          permission: permissions.DISPLAY_EDIT,
        },
      },
      {
        path: "/admin/hien-thi/website-lien-ket",
        name: "manager.display.linked_website",
        component: () =>
          import("@/views/manager/pages/display/linked_website/list/index.vue"),
        meta: {
          pageTitle: "Website liên kết",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.display.linked_website.add",
            permission: permissions.DISPLAY_ADD,
          },
          permission: permissions.DISPLAY_ACCESS,
        },
      },
      {
        path: "/admin/hien-thi/website-lien-ket/add",
        name: "manager.display.linked_website.add",
        component: () =>
          import(
            "@/views/manager/pages/display/linked_website/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Tạo website liên kết",
          breadcrumbs: [
            {
              title: "Danh sách website liên kết",
              routeName: "manager.display.linked_website",
            },
            {
              title: "Tạo website liên kết",
              routeName: "manager.display.linked_website.add",
            },
          ],
          permission: permissions.DISPLAY_ADD,
        },
      },
      {
        path: "/admin/hien-thi/website-lien-ket/edit/:id",
        name: "manager.display.linked_website.edit",
        component: () =>
          import(
            "@/views/manager/pages/display/linked_website/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Cập nhật website liên kết",
          breadcrumbs: [
            {
              title: "Danh sách website liên kết",
              routeName: "manager.display.linked_website",
            },
            {
              title: "Cập nhật website liên kết",
              routeName: "manager.display.linked_website.edit",
            },
          ],
          permission: permissions.DISPLAY_EDIT,
        },
      },
      {
        path: "/admin/noi-dung/thong-bao-chung",
        name: "manager.notifications",
        component: () =>
          import("@/views/manager/pages/notifications/list/index.vue"),
        meta: {
          pageTitle: "Thông báo",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.notifications.add",
            permission: permissions.NOTIFICATION_ADD,
          },
          permission: permissions.NOTIFICATION_ACCESS,
        },
      },
      {
        path: "/admin/noi-dung/thong-bao-chung/add",
        name: "manager.notifications.add",
        component: () =>
          import("@/views/manager/pages/notifications/add_edit/index.vue"),
        meta: {
          pageTitle: "Tạo thông báo",
          breadcrumbs: [
            {
              title: "Danh sách thông báo",
              routeName: "manager.notifications",
            },
            {
              title: "Tạo thông báo",
              routeName: "manager.notifications.add",
            },
          ],
          permission: permissions.NOTIFICATION_ADD,
        },
      },
      {
        path: "/admin/noi-dung/thong-bao-chung/edit/:id",
        name: "manager.notifications.edit",
        component: () =>
          import("@/views/manager/pages/notifications/add_edit/index.vue"),
        meta: {
          pageTitle: "Cập nhật thông báo",
          breadcrumbs: [
            {
              title: "Danh sách thông báo",
              routeName: "manager.notifications",
            },
            {
              title: "Cập nhật thông báo",
              routeName: "manager.notifications.edit",
            },
          ],
          permission: permissions.NOTIFICATION_EDIT,
        },
      },
      {
        path: "/admin/noi-dung/thong-bao-chung/detail/:id",
        name: "manager.notifications.detail",
        component: () =>
          import("@/views/manager/pages/notifications/detail/index.vue"),
        meta: {
          pageTitle: "Chi tiết thông báo",
          breadcrumbs: [
            {
              title: "Danh sách thông báo",
              routeName: "manager.notifications",
            },
            {
              title: "Chi tiết thông báo",
              routeName: "manager.notifications.detail",
            },
          ],
          permission: permissions.NOTIFICATION_ACCESS,
        },
      },
      {
        path: "/admin/cau-hinh",
        name: "manager.config",
        component: () =>
          import("@/views/manager/pages/config/global/index.vue"),
        meta: {
          pageTitle: "Quản lý cấu hình",
          breadcrumbs: [],
          permission: permissions.CONFIGURATION_MANAGER_EDIT,
        },
        children: [
          {
            path: "generalConfig",
            name: "general-config",
            component: () =>
              import(
                "@/views/manager/pages/config/global/settingItem/generalConfig.vue"
              ),
            meta: {
              breadcrumbs: ["Cài đặt chung"],
              isScrollToTop: true,
            },
          },
          {
            path: "bannerBigConfig",
            name: "banner-big-config",
            component: () =>
              import(
                "@/views/manager/pages/config/global/settingItem/bannerBigConfig.vue"
              ),
            meta: {
              breadcrumbs: ["Cài đặt vị trí banner lớn"],
              isScrollToTop: true,
            },
          },
          {
            path: "bannerSmallConfig",
            name: "banner-small-config",
            component: () =>
              import(
                "@/views/manager/pages/config/global/settingItem/bannerSmallConfig.vue"
              ),
            meta: {
              breadcrumbs: ["Cài đặt vị trí banner nhỏ"],
              isScrollToTop: true,
            },
          },
          {
            path: "mobileConfig",
            name: "mobile-config",
            component: () =>
              import(
                "@/views/manager/pages/config/global/settingItem/mobileConfig.vue"
              ),
            meta: {
              breadcrumbs: ["Cài đặt hiển thị trên mobile"],
              isScrollToTop: true,
            },
          },
          {
            path: "logConfig",
            name: "log-config",
            component: () =>
              import(
                "@/views/manager/pages/config/global/settingItem/logConfig.vue"
              ),
            meta: {
              breadcrumbs: ["Cài đặt log"],
              isScrollToTop: false,
            },
          },
          {
            path: "certifyConfig",
            name: "certify-config",
            component: () =>
              import(
                "@/views/manager/pages/config/global/settingItem/certifyConfig.vue"
              ),
            meta: {
              breadcrumbs: ["Cài đặt log"],
              isScrollToTop: false,
            },
          },
          // {
          //   path: "displayBannerConfig",
          //   name: "display-banner-config",
          //   component: () =>
          //     import(
          //       "@/views/manager/pages/config/global/settingItem/displayBannerConfig.vue"
          //     ),
          //   meta: {
          //     breadcrumbs: ["Cài đặt hiển thị banner"],
          //     isScrollToTop: true,
          //   },
          // },
        ],
      },
      {
        path: "/admin/thu-thap-thong-tin",
        name: "manager.collect",
        component: () => import("@/views/manager/pages/collect/index.vue"),
        meta: {
          pageTitle: "Thu thập thông tin",
          breadcrumbs: [],
          permission: permissions.COLLECT_INFORMATION_ACCESS,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do",
        name: "manager.map",
        component: () => import("@/views/manager/pages/collect/index.vue"),
        meta: {
          pageTitle: "Khai thác dữ liệu bản đồ",
          breadcrumbs: [],
          permission: permissions.GIS_ACCESS,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/nhaplieu",
        name: "manager.map.import",
        component: () => import("@/views/manager/pages/map/import/index.vue"),
        meta: {
          pageTitle: "Nhập liệu",
          breadcrumbs: [],
          permission: permissions.GIS_ACCESS,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/tinh",
        name: "manager.map.province",
        component: () =>
          import("@/views/manager/pages/map/province/list/index.vue"),
        meta: {
          pageTitle: "Danh sách tỉnh",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.map.province.add",
            permission: permissions.GIS_ADD,
          },
          permission: permissions.GIS_ACCESS,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/tinh/add",
        name: "manager.map.province.add",
        component: () =>
          import("@/views/manager/pages/map/province/add_edit/index.vue"),
        meta: {
          pageTitle: "Thêm mới tỉnh",
          breadcrumbs: [
            {
              title: "Danh sách tỉnh",
              routeName: "manager.map.province",
            },
            {
              title: "Thêm mới tỉnh",
              routeName: "manager.map.province.add",
            },
          ],
          permission: permissions.GIS_ADD,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/tinh/edit/:id",
        name: "manager.map.province.edit",
        component: () =>
          import("@/views/manager/pages/map/province/add_edit/index.vue"),
        meta: {
          pageTitle: "Cập nhật tỉnh",
          breadcrumbs: [
            {
              title: "Danh sách tỉnh",
              routeName: "manager.map.province",
            },
            {
              title: "Cập nhật tỉnh",
              routeName: "manager.map.province.edit",
            },
          ],
          permission: permissions.GIS_EDIT,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/huyen",
        name: "manager.map.district",
        component: () =>
          import("@/views/manager/pages/map/district/list/index.vue"),
        meta: {
          pageTitle: "Danh sách huyện",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.map.district.add",
            permission: permissions.GIS_ADD,
          },
          permission: permissions.GIS_ACCESS,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/huyen/add",
        name: "manager.map.district.add",
        component: () =>
          import("@/views/manager/pages/map/district/add_edit/index.vue"),
        meta: {
          pageTitle: "Thêm mới huyện",
          breadcrumbs: [
            {
              title: "Danh sách huyện",
              routeName: "manager.map.district",
            },
            {
              title: "Thêm mới huyện",
              routeName: "manager.map.district.add",
            },
          ],
          permission: permissions.GIS_ADD,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/huyen/edit/:id",
        name: "manager.map.district.edit",
        component: () =>
          import("@/views/manager/pages/map/district/add_edit/index.vue"),
        meta: {
          pageTitle: "Cập nhật huyện",
          breadcrumbs: [
            {
              title: "Danh sách huyện",
              routeName: "manager.map.district",
            },
            {
              title: "Cập nhật huyện",
              routeName: "manager.map.district.edit",
            },
          ],
          permission: permissions.GIS_EDIT,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/xa",
        name: "manager.map.commune",
        component: () =>
          import("@/views/manager/pages/map/commune/list/index.vue"),
        meta: {
          pageTitle: "Danh sách xã",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.map.commune.add",
            permission: permissions.GIS_ADD,
          },
          permission: permissions.GIS_ACCESS,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/xa/them",
        name: "manager.map.commune.add",
        component: () =>
          import("@/views/manager/pages/map/commune/add_edit/index.vue"),
        meta: {
          pageTitle: "Tạo xã",
          breadcrumbs: [
            {
              title: "Danh sách xã",
              routeName: "manager.map.commune",
            },
            {
              title: "Tạo xã",
              routeName: "manager.map.commune.add",
            },
          ],
          permission: permissions.GIS_ADD,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/xa/chinh-sua/:id",
        name: "manager.map.commune.edit",
        component: () =>
          import("@/views/manager/pages/map/commune/add_edit/index.vue"),
        meta: {
          pageTitle: "Cập nhật xã",
          breadcrumbs: [
            {
              title: "Danh sách xã",
              routeName: "manager.map.commune",
            },
            {
              title: "Cập nhật xã",
              routeName: "manager.map.commune.edit",
            },
          ],
          permission: permissions.GIS_EDIT,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/linh-vuc-dieu-tra",
        name: "manager.map.linhvuc-dieutra",
        component: () =>
          import("@/views/manager/pages/map/linhvuc-dieutra/list/index.vue"),
        meta: {
          pageTitle: "Danh sách lĩnh vực điều tra",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.map.linhvuc-dieutra.add",
            permission: permissions.GIS_ADD,
          },
          permission: permissions.GIS_ACCESS,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/linh-vuc-dieu-tra/add",
        name: "manager.map.linhvuc-dieutra.add",
        component: () =>
          import(
            "@/views/manager/pages/map/linhvuc-dieutra/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Tạo lĩnh vực điều tra",
          breadcrumbs: [
            {
              title: "Danh sách lĩnh vực điều tra",
              routeName: "manager.map.linhvuc-dieutra",
            },
            {
              title: "Tạo lĩnh vực điều tra",
              routeName: "manager.map.linhvuc-dieutra.add",
            },
          ],
          permission: permissions.GIS_ADD,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/linh-vuc-dieu-tra/edit/:id",
        name: "manager.map.linhvuc-dieutra.edit",
        component: () =>
          import(
            "@/views/manager/pages/map/linhvuc-dieutra/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Cập nhật lĩnh vực điều tra",
          breadcrumbs: [
            {
              title: "Danh sách lĩnh vực điều tra",
              routeName: "manager.map.linhvuc-dieutra",
            },
            {
              title: "Cập nhật lĩnh vực điều tra",
              routeName: "manager.map.linhvuc-dieutra.edit",
            },
          ],
          permission: permissions.GIS_EDIT,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/cuoc-dieu-tra",
        name: "manager.map.cuocdieutra",
        component: () =>
          import("@/views/manager/pages/map/cuocdieutra/list/index.vue"),
        meta: {
          pageTitle: "Danh sách cuộc điều tra",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.map.cuocdieutra.add",
            permission: permissions.GIS_ADD,
          },
          permission: permissions.GIS_ACCESS,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/cuoc-dieu-tra/them",
        name: "manager.map.cuocdieutra.add",
        component: () =>
          import("@/views/manager/pages/map/cuocdieutra/add_edit/index.vue"),
        meta: {
          pageTitle: "Tạo cuộc điều tra",
          breadcrumbs: [
            {
              title: "Danh sách cuộc điều tra",
              routeName: "manager.map.cuocdieutra",
            },
            {
              title: "Tạo cuộc điều tra",
              routeName: "manager.map.cuocdieutra.add",
            },
          ],
          permission: permissions.GIS_ADD,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/cuoc-dieu-tra/chinh-sua/:id",
        name: "manager.map.cuocdieutra.edit",
        component: () =>
          import("@/views/manager/pages/map/cuocdieutra/add_edit/index.vue"),
        meta: {
          pageTitle: "Cập nhật cuộc điều tra",
          breadcrumbs: [
            {
              title: "Danh sách cuộc điều tra",
              routeName: "manager.map.cuocdieutra",
            },
            {
              title: "Cập nhật cuộc điều tra",
              routeName: "manager.map.cuocdieutra.edit",
            },
          ],
          permission: permissions.GIS_EDIT,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/phan-to",
        name: "manager.map.phan-to",
        component: () =>
          import("@/views/manager/pages/map/phan-to/list/index.vue"),
        meta: {
          pageTitle: "Danh sách phân tổ",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.map.phan-to.add",
            permission: permissions.GIS_ADD,
          },
          permission: permissions.GIS_ACCESS,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/phan-to/add",
        name: "manager.map.phan-to.add",
        component: () =>
          import("@/views/manager/pages/map/phan-to/add_edit/index.vue"),
        meta: {
          pageTitle: "Thêm phân tổ",
          permission: permissions.GIS_ADD,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/phan-to/edit/:id",
        name: "manager.map.phan-to.edit",
        component: () =>
          import("@/views/manager/pages/map/phan-to/add_edit/index.vue"),
        meta: {
          pageTitle: "Cập nhật phân tổ",
          permission: permissions.GIS_EDIT,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/cau-hinh",
        name: "manager.map.cau-hinh",
        component: () => import("@/views/manager/pages/map/cau-hinh/index.vue"),
        meta: {
          pageTitle: "Cấu hình",
          breadcrumbs: [],
          permission: permissions.GIS_ACCESS,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/danh-muc-chi-tieu",
        name: "manager.map.danh-muc-chi-tieu",
        component: () =>
          import("@/views/manager/pages/map/danhmuc-chitieu/list/index.vue"),
        meta: {
          pageTitle: "Danh mục chỉ tiêu",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.map.danh-muc-chi-tieu.add",
            permission: permissions.GIS_ADD,
          },
          permission: permissions.GIS_ACCESS,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/danh-muc-chi-tieu/add",
        name: "manager.map.danh-muc-chi-tieu.add",
        component: () =>
          import(
            "@/views/manager/pages/map/danhmuc-chitieu/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Tạo danh mục chỉ tiêu",
          breadcrumbs: [
            {
              title: "Danh sách mục chỉ tiêu",
              routeName: "manager.map.danh-muc-chi-tieu",
            },
            {
              title: "Tạo danh mục chỉ tiêu",
              routeName: "manager.map.danh-muc-chi-tieu.add",
            },
          ],
          permission: permissions.GIS_ADD,
        },
      },
      {
        path: "/admin/khai-thac-du-lieu-ban-do/danh-muc-chi-tieu/edit/:id",
        name: "manager.map.danh-muc-chi-tieu.edit",
        component: () =>
          import(
            "@/views/manager/pages/map/danhmuc-chitieu/add_edit/index.vue"
          ),
        meta: {
          pageTitle: "Cập nhật mục chỉ tiêu",
          breadcrumbs: [
            {
              title: "Danh sách thông báo",
              routeName: "manager.map.danh-muc-chi-tieu.add",
            },
            {
              title: "Cập nhật mục chỉ tiêu",
              routeName: "manager.map.danh-muc-chi-tieu.edit",
            },
          ],
          permission: permissions.GIS_EDIT,
        },
      },
      {
        path: "/admin/cau-hinh-website",
        name: "manager.subsite-config",
        component: () =>
          import("@/views/manager/pages/subsite-config/list/index.vue"),
        meta: {
          pageTitle: "Cấu hình website",
          btnNew: {
            text: "Tạo mới",
            routeName: "manager.subsite-config.add",
            permission: " ",
          },
          permission: permissions.SUBSITE_CONFIG_ACCESS,
        },
      },
      {
        path: "/admin/cau-hinh-website/add",
        name: "manager.subsite-config.add",
        component: () =>
          import("@/views/manager/pages/subsite-config/add_edit/index.vue"),
        meta: {
          pageTitle: "Tạo cấu hình website",
          breadcrumbs: [
            {
              title: "Danh sách cấu hình website",
              routeName: "manager.subsite-config",
            },
            {
              title: "Tạo cấu hình website",
              routeName: "manager.subsite-config.add",
            },
          ],
          permission: permissions.SUBSITE_CONFIG_ADD,
        },
      },
      {
        path: "/admin/cau-hinh-website/edit/:id",
        name: "manager.subsite-config.edit",
        component: () =>
          import("@/views/manager/pages/subsite-config/add_edit/index.vue"),
        meta: {
          pageTitle: "Cập nhật cấu hình website",
          breadcrumbs: [
            {
              title: "Danh sách cấu hình website",
              routeName: "manager.subsite-config",
            },
            {
              title: "Cập nhật cấu hình website",
              routeName: "manager.subsite-config.edit",
            },
          ],
          permission: permissions.SUBSITE_CONFIG_EDIT,
        },
      },
      {
        path: "/admin/cau-hinh-website/detail/:id",
        name: "manager.subsite-config.detail",
        component: () =>
          import("@/views/manager/pages/subsite-config/detail/index.vue"),
        meta: {
          pageTitle: "Chi tiết cấu hình website",
          breadcrumbs: [
            {
              title: "Danh sách cấu hình website",
              routeName: "manager.subsite-config",
            },
            {
              title: "Chi tiết cấu hình website",
              routeName: "manager.subsite-config.detail",
            },
          ],
          permission: permissions.SUBSITE_CONFIG_ACCESS,
        },
      },
      {
        path: "/admin/nhat-ky",
        name: "manager.activity-logs",
        component: () =>
          import("@/views/manager/pages/activity-logs/list/index.vue"),
        meta: {
          pageTitle: "Quản lý nhật ký hoạt động",
          breadcrumbs: [],
        },
      },
      // {
      //   path: "/user/detail/:id",
      //   name: "user.detail",
      //   component: () => import("@/views/manager/pages/user/detail/index.vue"),
      //   meta: {
      //     pageTitle: "ユーザ詳細",
      //     breadcrumbs: [
      //       {
      //         title: "ユーザ管理",
      //         routeName: "user.list",
      //       },
      //       {
      //         title: "ユーザ詳細",
      //         routeName: "user.detail",
      //       },
      //     ],
      //   },
      // },
      {
        path: "/admin/huong-dan-su-dung",
        name: "manager.huong-dan-su-dung",
        component: () =>
          import("@/views/manager/pages/huong-dan-su-dung/index.vue"),
        meta: {
          pageTitle: "",
          breadcrumbs: [],
        },
      },
      {
        path: "/admin/hien-thi/gioi-thieu",
        name: "manager.gioi-thieu",
        component: () =>
          import("@/views/manager/pages/display/introduce/global/index.vue"),
        meta: {
          pageTitle: "Giới thiệu website",
          breadcrumbs: [
            {
              routeName: "manager.subsite-config",
            },
          ],
          permission: permissions.SUBSITE_CONFIG_ADD,
        },
        children: [
          {
            path: "chuc-nang-nhiem-vu",
            name: "mission-function",
            component: () =>
              import(
                "@/views/manager/pages/display/introduce/global/settingItem/missionFunction.vue"
              ),
            meta: {
              breadcrumbs: ["Chức năng nhiệm vụ"],
              isScrollToTop: true,
            },
          },
          {
            path: "lich-su-phat-trien",
            name: "development-history",
            component: () =>
              import(
                "@/views/manager/pages/display/introduce/global/settingItem/developmentHistory.vue"
              ),
            meta: {
              breadcrumbs: ["Lịch sử phát triển"],
              isScrollToTop: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: "/",
    redirect: "/admin/dang-nhap",
    component: () => import("@/layouts/AuthLayout.vue"),
    children: [
      {
        path: "/admin/dang-nhap",
        name: "dang-nhap",
        component: () =>
          import("@/views/manager/authentication/basic-flow/SignIn.vue"),
        meta: {
          pageTitle: "Đăng nhập",
        },
      },
      {
        path: "/admin/forgot-password",
        name: "forgot-password",
        component: () =>
          import(
            "@/views/manager/authentication/basic-flow/ForgotPassword.vue"
          ),
        meta: {
          pageTitle: "Quên mật khẩu",
        },
      },
      {
        path: "/admin/sign-up",
        name: "sign-up",
        component: () =>
          import("@/views/manager/authentication/basic-flow/SignUp.vue"),
        meta: {
          pageTitle: "Đăng ký",
        },
      },
      {
        path: "/admin/password-reset",
        name: "password-reset",
        component: () =>
          import("@/views/manager/authentication/basic-flow/PasswordReset.vue"),
        meta: {
          pageTitle: "Password reset",
        },
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/layouts/SystemLayout.vue"),
    children: [
      {
        // the 404 route, when none of the above matches
        path: "/404",
        name: "404",
        component: () => import("@/views/manager/authentication/Error404.vue"),
        meta: {
          pageTitle: "Error 404",
        },
      },
      {
        path: "/500",
        name: "500",
        component: () => import("@/views/manager/authentication/Error500.vue"),
        meta: {
          pageTitle: "Error 500",
        },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta?.middleware == "auth") {
    if (!store.getters.isUserAuthenticated) {
      next({ name: "dang-nhap" });
    }

    // verify auth token before each page change
    //store.dispatch(Actions.VERIFY_AUTH, { api_token: JwtService.getToken() });
    if (Object.keys(store.getters.currentUser).length == 0) {
      store.dispatch(Actions.VERIFY_AUTH, {});
    }
  }

  // current page view title
  document.title = `${to.meta.pageTitle}`;

  // reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  // Scroll page to top on every route change
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
  next();
});

export default router;
